import {Link} from "react-router-dom";
import "../Common.css"

function Bolbi()
{
    return (
        <div>
            <p>Bolbi</p>
            <Link to="/Games" className="logo"></Link>
        </div>
      )
}

export default Bolbi;